import { EmployeeBankAccountMutationDTO } from "../../models/employee-bank-accounts/mutations/employee-bank-account-mutation-dto";
import { EmployeeBankAccountMutationSTO } from "../../models/employee-bank-accounts/mutations/employee-bank-account-mutation-sto";
import { BaseApiService } from "../base/base-api.service";

export class EmployeeBankAccountMutationsApiService extends BaseApiService<
  EmployeeBankAccountMutationDTO,
  EmployeeBankAccountMutationSTO
> {
  constructor() {
    super({
      servicePath: "/EmployeeBankAccountMutations",
      loadItemsPath: "/GetEmployeeBankAccountMutations",
      saveItemsPath: "/SaveEmployeeBankAccountMutations",
    });
  }
}
